import { useMemo } from "react";
import styled from "rn-css";
import { View } from "react-native";
import useToggleStore from "../../store/useToggle.store";
import { silver } from "../../StyleHelpers";

/**
 * Styled shimmer loader component.
 * Appears when `isShimmerLoading` is false.
 */
const StyledLoader = styled.View<any>`
	height: 100%;
	width: 100%;
	opacity: 0.2;
	background-color: ${silver};
	border-radius: ${(props) => (props.isBorder ? "1rem" : 0)};
`;

/**
 * ImgProgressBar component
 * - Uses global toggle state to determine if shimmer loading is active.
 * - Renders a placeholder shimmer View when loading.
 * - Renders a styled fallback loader when not loading.
 */
const ImgProgressBar = (props: any) => {
	const isShimmerLoading = useToggleStore((state: any) => state.isShimmerLoading);

	return useMemo(
		() =>
			isShimmerLoading ? <View nativeID={`${props.isNoBorder ? "shimmerNoBorder" : "shimmer"}`} /> : <StyledLoader isBorder={props.isBorder} />,
		[],
	);
};

export default ImgProgressBar;
